export enum QUERY_KEYS {
  createAddonImage = 'create-addon-image',
  createAddonPreset = 'create-addon-preset',
  createAddonPresetImage = 'create-addon-preset-image',
  createBulkEventAddons = 'create-event-bulk-addons',
  createEventAddon = 'create-event-addon',
  deleteAddon = 'delete-addons',
  deleteAddonImage = 'delete-addon-image',
  deleteAddonOffer = 'delete-addon-offer',
  deleteAddonPreset = 'delete-addon-preset',
  deleteAddonPresetImage = 'delete-addon-preset-image',
  editAddon = 'edit-event-addon',
  editAddonPreset = 'edit-addon-preset',
  getAddons = 'get-event-addons',
  getAddonsPresets = 'addons-by-company-club',
  getOfferAddons = 'get-offer-addons',
  reorderAddonImages = 'reorder-addon-images',
  reorderAddonPresetImages = 'reorder-addon-preset-images',
}
